export default {
  page: {
    home: "Home",
    search: "Search",
    skills: "Skills",
    skills_stats: "Statistics",
    dashboard: "Dashboard",
    questionnaires: "Questionnaires",
    weblinks: "Your useful links",
    gradebook: "Your gradebooks",
    attestations: "Your attendance records",
    message: "Inbox",
    document: "Your shared documents",
    document_add: "Add a document",
    document_add_note: "Add a note",
    lessons: "Your lessons",
    timetable: "Your timetable",
    absence: "Attendance management",
    profile: "Profile",
    questionnaire: "Questionnaire",
    training_course_list: "List of year training courses",
    training_list: "List of training courses",
    registration_dashboard: "Registrations dashboard",
    training_dashboard: "Training dashboard",
    pre_registration_edit: "Configuration of the pre-registration form",
    step_edit: "Steps configuration",
    pre_registration: "Pre-registration form",
    contract: "Contract",
    driver_licence_config: "Management of B driving licence subsidies",
    driver_licence_list: "List of applications for B driving licence support",
    driver_licence: "Help with B driving licence",
    login: "Log in",
    notepad: "Notepad",
    new_message: "New message",
    new_password: "New password",
    reset_password: "Reset password",
    error: "Error",
    switch: "Log in",
    maintenance: "Maintenance",
    download: {
      title: "File download",
      processing: "Download in progress...",
      success: "File downloaded successfully!",
    },
    platformNotFount: "Platform not configured",
    registration_list: "List of pre-registration forms",
  },
};
